import { getCurrentBrowserFingerPrint } from "@rajesh896/broprint.js";
import { isEmpty } from "lodash";
import { convertToDateObject, getCurrentCheckoutToken } from "./utils";
import { applyOffer, setOfferMisMatchModal } from "../slices/OfferSlice";

let fingerPrintValue = "";

getCurrentBrowserFingerPrint().then((fingerprint) => {
  fingerPrintValue = fingerprint;
});

function clearEmpties(o) {
  for (var k in o) {
    if (!o[k] || typeof o[k] !== "object") {
      continue;
    }
    clearEmpties(o[k]);
    if (Object.keys(o[k]).length === 0) {
      o[k] = undefined;
    }
  }
  return o;
}

export const buildPaymentRequest = (
  instrumentTypeValue,
  updatedShopperDetails,
  sessionDetails,
  emiCode,
  offerCode,
  surchargeCode
) => {
  const urlParams = new URLSearchParams(window.location.search);
  const utmSourceParam = urlParams.get("utm_source");
  const utmMediumParam = urlParams.get("utm_medium");
  const utmCampaignParam = urlParams.get("utm_campaign");
  // sessionDetails.token can be briefly empty right after a session (re)fetch
  // starts (paymentSession.pending wipes it while the request is in flight).
  // Fall back to the token already in the URL/storage so we don't send
  // POST /checkout/sessions/undefined.
  const paymentRequest = {
    token: sessionDetails?.token || getCurrentCheckoutToken(),
    payload: {
      instrumentDetails: {
        type: instrumentTypeValue,
      },
      browserData: {
        userAgentHeader: navigator.userAgent,
        browserLanguage: navigator.language,
        timeZoneOffSet: new Date().getTimezoneOffset(),
        browserFingerprint: fingerPrintValue,
      },
    },
  };

  if (emiCode) {
    paymentRequest.payload.offers = [emiCode];
  }
  if (offerCode?.length) {
    if (paymentRequest?.payload?.offers?.length) {
      paymentRequest.payload.offers = [...paymentRequest.payload.offers, ...offerCode]
    } else {
      paymentRequest.payload.offers = offerCode;
    }
  }

  if (surchargeCode?.length) {
    paymentRequest.payload.surcharges = surchargeCode
  }

  if (
    utmSourceParam !== null ||
    utmMediumParam !== null ||
    utmCampaignParam !== null
  ) {
    paymentRequest.payload.trackingDetails = {};
    if (utmSourceParam !== null) {
      paymentRequest.payload.trackingDetails.source = utmSourceParam;
    }
    if (utmMediumParam !== null) {
      paymentRequest.payload.trackingDetails.medium = utmMediumParam;
    }
    if (utmCampaignParam !== null) {
      paymentRequest.payload.trackingDetails.campaign = utmCampaignParam;
    }
  }
  let newShopperDetails = { ...updatedShopperDetails };
  const shopperRef = localStorage.getItem("shopperRef")
  if (shopperRef) {
    newShopperDetails.uniqueReference = shopperRef
  }
  if (!isEmpty(updatedShopperDetails.dateOfBirth)) {
    newShopperDetails.dateOfBirth = convertToDateObject(updatedShopperDetails.dateOfBirth, true, true);
  }
  if (instrumentTypeValue === "qris/qr" || instrumentTypeValue === "pix/qr") {
    delete newShopperDetails.deliveryAddress;
  }
  paymentRequest.payload.shopper = newShopperDetails;
  return clearEmpties(JSON.parse(JSON.stringify(paymentRequest)));
};


// utils/offerUtils.js
export const handleFormatDiscount = ({
  type,
  callback,
  dispatch,
  sessionDetails,
  appliedOfferDetail,
  selectedInstrument,
  cardBinData,
  showTotalPaymentSummaryField,
  totalPaymentSummaryValue,
}) => {
  if (!appliedOfferDetail || !appliedOfferDetail.codes) {
    callback();
    return;
  }

  const evaluatedOffers = appliedOfferDetail.codes;
  const payloadAmount = showTotalPaymentSummaryField ? totalPaymentSummaryValue : sessionDetails?.paymentDetails?.money?.amount
  let payload = {
    offerSearchRequest: {
      currency: sessionDetails?.paymentDetails?.money?.currencyCode,
      minAmount: payloadAmount,
      maxAmount: payloadAmount,
      offers: evaluatedOffers,
    }
  };

  let paymentMethod = {};

  switch (type) {
    case "NetBanking":
    case "Wallet":
    case "CardlessEMI":
    case "BuyNowPayLater":
      paymentMethod = {
        type: selectedInstrument?.type,
        brand: selectedInstrument?.brand,
      };
      break;

    case "CardEmi":
      paymentMethod = {
        "type": "Emi",
        "brand": selectedInstrument?.brand,
        "duration": selectedInstrument?.emiMethod?.duration

      }
      if (cardBinData?.issuerName) {
        paymentMethod.issuer = cardBinData.issuerName;
      }
      if (cardBinData?.paymentMethod?.classification) {
        paymentMethod.classifications = [cardBinData.paymentMethod.classification];
      }
      break
    case "Card":
      paymentMethod = {
        type: "Card",
        network: [cardBinData?.paymentMethod?.brand],
      };
      if (cardBinData?.issuerName) {
        paymentMethod.issuer = cardBinData.issuerName;
      }
      if (cardBinData?.paymentMethod?.classification) {
        paymentMethod.classifications = [cardBinData.paymentMethod.classification];
      }
      break;

    case "Upi":
      paymentMethod = { type: "Upi" };
      break;
    case "UpiOneTimeMandate":
      paymentMethod = { type: "UpiOneTimeMandate" };
      break;
  }


  payload.offerSearchRequest.paymentMethod = paymentMethod;

  dispatch(
    applyOffer({
      sessionToken: sessionDetails?.token,
      payload,
      handleSuccess: callback,
      handleError: () => {
        dispatch(setOfferMisMatchModal(true));
      },
      returnValue: false
    })
  );
};

export const buildDccRequest = ({ instrument, updatedShopperDetails, sessionDetails }) => {
  let { countryCode, clientPosId, orderId, localeCode, legalEntity: { code } } = sessionDetails?.paymentDetails?.context;
  let { amount, currencyCode } = sessionDetails?.paymentDetails?.money;
  let { firstName, lastName, email, uniqueReference, phoneNumber, panNumber, dateOfBirth } = updatedShopperDetails;
  let newDob = dateOfBirth;
  if (!isEmpty(dateOfBirth)) {
    newDob = convertToDateObject(dateOfBirth, true, true);
  }
  let data = {
    context: {
      countryCode,
      legalEntity: { code },
      clientPosId,
      orderId,
      localCode: localeCode
    },
    money: { amount, currencyCode },
    shopper: {
      firstName, lastName, email, uniqueReference, phoneNumber, panNumber, dateOfBirth: newDob
    },
    instrument
  }
  return clearEmpties(JSON.parse(JSON.stringify(data)));
}

export const handlePrintCouponCondition = (offerData) => {
  try {
    const paymentMethods = offerData?.criteria?.applicableTo?.paymentMethods;

    if (!Array.isArray(paymentMethods) || paymentMethods.length === 0) {
      return "all transactions";
    }

    const method = paymentMethods[0];
    const type = method?.type?.toLowerCase();

    if (!type) return "all transactions";

    switch (type) {
      case "card": {
        const issuer = method?.issuerTitle || "";
        const classifications = method?.classifications || [];
        const network = method?.network || [];

        const networkText = network.map((el, i) =>
          i === 0 ? `${el}` : i === network.length - 1 ? ` & ${el} ` : `, ${el}`
        ).join("");

        const classificationText = classifications?.length ? classifications.length === 1
          ? classifications[0]
          : `both ${classifications.join(" and ")}` : "";

        return `  transactions made using ${issuer} ${classificationText} Card${network.length ? ` issued on ${networkText}` : ""}`.trim();
      }
      case "emi":
        const issuer = method?.issuerTitle || "";
        const classifications = method?.classifications || [];
        const network = method?.network || [];

        const networkText = network.map((el, i) =>
          i === 0 ? `${el}` : i === network.length - 1 ? ` & ${el} ` : `, ${el}`
        ).join("");

        const classificationText = classifications?.length ? classifications.length === 1
          ? classifications[0]
          : `both ${classifications.join(" and ")}` : "";

        return ` Emi transactions made using ${issuer} ${classificationText} Card${network.length ? ` issued on ${networkText}` : ""}`.trim();
      case "netbanking":
        return method?.brandTitle ? `netbanking transaction made using ${method?.brandTitle}` : " all netbanking transaction";
      case "wallet":
        return method?.brandTitle ? `transaction made using ${method.brandTitle} wallet` : " all transactions made using wallets";
      case "buynowpaylater":
        return method?.brandTitle ? ` transactions made using ${method.brandTitle} ` : " all BNPL transactions ";
      case "upi":
        return "transaction made using UPI";
      default:
        return "all transactions";
    }
  } catch (error) {
    console.error("Error in handlePrintCouponCondition:", error);
    return "all transactions";
  }
};